import * as React from 'react';
import { connect } from 'react-redux';
import { updateBreadCrumbs } from '../../../redux/Actions/BreadCrumbs/ActionCreators';

import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { withRouter } from 'react-router';
import { Dispatch } from 'redux';

import './SearchSimple.css';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

class SearchSimple extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    const {
      match: { params }
    } = this.props;

    this.state = {
      templateId: params.templateId
    };
  }

  public componentDidMount() {
    const items: IBreadcrumbItem[] = [{ text: 'Home', key: '/home' }, { text: 'Search', key: '/search', isCurrentItem: true }];
    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    return (
      <div style={{ textAlign: 'center', width: '100%', paddingTop: '30px' }}>
        <span className="ms-font-su">You just searched for {this.props.location.search}</span>
        <span>{new Date().getMilliseconds()}</span>
      </div>
    );
  }
}

export default withRouter(connect(
  null,
  mapDispatchToProps
)(SearchSimple) as any);
